module.exports = __webpack_public_path__ + "media/parents/choosing-a-college-major-career-path-8ebabc9f.svg";